import { useState } from 'react';
import { FaSignOutAlt, FaTimes } from 'react-icons/fa';
import { NavLink, useLocation } from 'react-router-dom';
import Menu from "../../json/menu_admin.json";
import AdminNavbar from './NavbarAdmin';
import IconRenderer from '../Panel/IconRenderer';
import { isAuth, removeLocalStorage } from '../../helper/auth';

const Sidebar = () => {
    const paths = useLocation().pathname;
    const user = isAuth();
    const [showSidebar, setShowSidebar] = useState('-left-64');
    const url = paths;
    const isOpen = showSidebar === 'left-0';

    const closeSidebar = () => setShowSidebar('-left-64');

    const logout = async () => {
        await removeLocalStorage();
        window.location.href = '/login-admin';
    };

    return (
        <>
            <AdminNavbar
                showSidebar={showSidebar}
                setShowSidebar={setShowSidebar}
            />

            {/* Overlay blur menutupi konten + navbar; sidebar tetap di atas */}
            {isOpen && (
                <div
                    className="fixed inset-0 bg-black/30 backdrop-blur-sm z-[46] md:hidden"
                    onClick={closeSidebar}
                    aria-hidden="true"
                />
            )}

            {/* Close di kanan sidebar (mobile) — di luar panel supaya tidak kepotong */}
            {isOpen && (
                <button
                    type="button"
                    onClick={closeSidebar}
                    className="md:hidden fixed top-4 left-[16.75rem] z-[60] w-9 h-9 rounded-full bg-zafu-green border border-white/25 text-white shadow-lg flex items-center justify-center"
                    aria-label="Tutup menu"
                >
                    <FaTimes className="text-sm" />
                </button>
            )}

            <div
                className={`h-screen bg-zafu-green fixed top-0 md:left-0 ${showSidebar} overflow-y-auto flex-row flex-nowrap overflow-hidden shadow-zafu-lg w-64 z-50 py-5 px-3 transition-all duration-300`}
            >
                <div className="flex flex-col min-h-full relative">
                    <div className="flex items-center gap-3 px-2 mb-6">
                        <div className="w-10 h-10 rounded-full bg-zafu-cream text-zafu-green font-display font-bold text-lg flex items-center justify-center shrink-0">
                            Z
                        </div>
                        <div className="text-left leading-tight">
                            <div className="text-white font-semibold text-sm tracking-wide">ZAFU RESIDENCE</div>
                            <div className="text-white/60 text-xs">Admin Panel</div>
                        </div>
                    </div>

                    <ul className="flex flex-col gap-1 list-none flex-1">
                        {Menu.map((item, index) => {
                            const active = url === item.link || (item.link !== '/admin' && url.startsWith(item.link));
                            return (
                                <NavLink
                                    key={index}
                                    to={item.link}
                                    className={active ? "zafu-sidebar-link-active" : "zafu-sidebar-link"}
                                >
                                    <li
                                        onClick={() => setTimeout(closeSidebar, 300)}
                                        className="flex items-center gap-3 w-full"
                                    >
                                        <span className="text-lg leading-none">
                                            <IconRenderer iconStr={item.icon} />
                                        </span>
                                        {item.name}
                                    </li>
                                </NavLink>
                            );
                        })}
                    </ul>

                    <div className="mt-auto pt-4 border-t border-white/10">
                        <div className="flex items-center gap-3 px-2 mb-3">
                            <div className="w-9 h-9 rounded-full bg-white/15 text-white text-sm font-semibold flex items-center justify-center">
                                {(user?.nama || 'A').charAt(0).toUpperCase()}
                            </div>
                            <div className="min-w-0">
                                <div className="text-white text-sm font-medium truncate">{user?.nama || 'Admin'}</div>
                                <div className="text-white/50 text-xs truncate">@{user?.username || 'admin'}</div>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={logout}
                            className="zafu-sidebar-link w-full text-left flex items-center gap-3 text-white/85"
                        >
                            <FaSignOutAlt className="text-lg text-white/90 shrink-0" />
                            Log Out
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Sidebar
